import { render, staticRenderFns } from "./permissionMatrix.vue?vue&type=template&id=6290e220&"
import script from "./permissionMatrix.vue?vue&type=script&lang=js&"
export * from "./permissionMatrix.vue?vue&type=script&lang=js&"
import style0 from "./permissionMatrix.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports